import type { IActivity } from '@/interfaces/IActivity'
import type { IDigestateJob, IEmployees, IHaulageJob, ISpreadingJob } from '@/interfaces'
import Base from './Base'

class Activity extends Base implements IActivity {
  title: string
  description: string
  haulageJobId: string
  haulageJob: IHaulageJob
  digestateJobId: string
  digestateJob: IDigestateJob
  spreadingJobId: string
  spreadingJob: ISpreadingJob
  userId: string
  user: IEmployees
  timestamp: string
  createdAt: string
  updatedAt: string
  archivedAt: string

  constructor(activity: any) {
    super(activity)
    this.title = activity?.title
    this.description = activity?.description
    this.haulageJobId = activity?.haulageJobId
    this.haulageJob = activity?.haulageJob
    this.digestateJobId = activity?.digestateJobId
    this.digestateJob = activity?.digestateJob
    this.spreadingJobId = activity?.spreadingJobId
    this.spreadingJob = activity?.spreadingJob
    this.timestamp = activity?.timestamp
    this.userId = activity?.userId
    this.user = activity?.user
    this.createdAt = activity?.createdAt
    this.updatedAt = activity?.updatedAt
    this.archivedAt = activity?.archivedAt
  }
}

export default Activity
